import React, { Component } from "react";
import { Redirect } from 'react-router-dom'
import { Card, message, Icon, Input, InputNumber, Button, Popconfirm, Form, Table, Divider, DatePicker } from "antd";
import "../App.css";
import { db } from '../firebase/firebase';

//editable
//editableCell

/** editable-start */
const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);
/** editable-end */

class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <InputNumber />;
    }
    return <Input />;
  };

  render() {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      ...restProps
    } = this.props;
    return (
      <EditableContext.Consumer>
        {(form) => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              {editing ? (
                <FormItem style={{ margin: 0 }}>
                  {getFieldDecorator(dataIndex, {
                    rules: [{
                      required: true,
                      message: `Please Input ${title}!`,
                    }],
                    initialValue: record[dataIndex],
                  })(this.getInput())}
                </FormItem>
              ) : restProps.children}
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}

export class Values extends Component {
  constructor(props) {
    super(props);

    this.state = {
      x: 500000,
      evastring: {},
      addingEvent: false,
      pendingTitle: "",
      pendingValue: "",
      invalidPage: false,
      data: [],
      editingKey: '',
      lowest: ''
    }

    this.pageCheck()

    this.columns = [
      {
        title: 'id',
        dataIndex: 'abc',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => { return a.abc.localeCompare(b.abc) },
      },
      {
        title: 'Key',
        dataIndex: 'keyy',
        ...this.getColumnSearchProps('keyy'),
        editable: true,
        sorter: (a, b) => { return a.keyy.localeCompare(b.keyy) },
      },
      {
        title: 'Value',
        dataIndex: 'value',
        ...this.getColumnSearchProps('value'),
        editable: true,
        sorter: (a, b) => { return a.value - b.value },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '15%',
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <span>
                  <EditableContext.Consumer>
                    {form => (
                      <Button
                        onClick={() => this.save(form, record.key)}
                        style={{ marginRight: 8 }}
                      >
                        Save
                    </Button>
                    )}
                  </EditableContext.Consumer>
                  <Button
                    type="primary"
                    style={{ marginRight: 8 }}
                    onClick={() => this.cancel(record.key)}
                  >
                    Cancel
                  </Button>
                </span>
              ) : (
                  <div>
                    <Button
                      type="primary"
                      onClick={() => this.edit(record.key)}
                    >
                      Edit
                </Button>
                    <Divider type="vertical" />

                    <Popconfirm
                      title="Confirm Delete?"
                      onConfirm={evt => this.deleteValue(record.key)}
                    >
                      <Button
                        type="danger"
                      >
                        Delete
                </Button>
                    </Popconfirm>

                  </div>
                )}
            </div>
          );
        },
      },
    ];

    // We want event handlers to share this context
    this.addValue = this.addValue.bind(this)
    this.deleteValue = this.deleteValue.bind(this)

    this.pullFromDB()
    this.getSmallestFreeNumber()
  }

  pageCheck = () => {
    var iden = this.props.match.params.id
    var tempName = this.props.match.params.name

    var self = this
    db.collection("project").doc(iden).get()
      .then(function (doc) {
        if (doc.exists && doc.data().name == tempName) {
          var evastring = {}
          evastring.member = doc.data().evastring_member
          evastring.nonmember = doc.data().evastring_nonmember
          evastring.member_result = 0
          evastring.nonmember_result = 0
          self.setState({
            invalidPage: false,
            evastring
          })
        } else {
          message.error("invalid url")
          if (self.state.invalidPage != null)
            self.setState({ invalidPage: true })
        }
      }).catch(function (error) {
        message.error("error url")
        if (self.state.invalidPage != null)
          self.setState({ invalidPage: true })
      })
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => { this.searchInput = node; }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
        </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
        </Button>
        </div>
      ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select())
      }
    },
    render: (text) => (
      text
    ),
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm()
    this.setState({ searchText: selectedKeys[0] })
  }

  handleReset = (clearFilters) => {
    clearFilters()
    this.setState({ searchText: '' })
  }

  pullFromDB() {
    // We listen for live changes to our events collection in Firebase
    db.collection("values").where('project', '==', this.props.match.params.id).onSnapshot(snapshot => {
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data()
        todo.id = doc.id;
        data.push(todo)
      })

      //sort by timestamp
      data.sort((a, b) => (a.timestamp > b.timestamp) ? -1 : 1)

      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }
      // console.log(data);

      // Anytime the state of our database changes, we update state
      this.setState({ data });

    })
  }

  async deleteValue(pid) {
    // console.log("delete event" + this.state.data[pid].id + JSON.stringify(this.state.data))
    await db
      .collection("values")
      .doc(this.state.data[pid].id)
      .delete();

  }

  convertNumberToABC(number) {
    return String.fromCharCode(number + 96)
  }

  getValueFromABC(str) {
    if (str == 'x')
      return this.state.x

    let result = this.state.data.find(obj => {
      return obj.abc === str
    })
    if (result)
      return result.value
  }

  getSmallestFreeNumber() {
    var lowest = 'ERROR'
    db.collection("values").where('project', '==', this.props.match.params.id).onSnapshot(snapshot => {
      let arrayofNumber = [];
      snapshot.forEach(doc => {
        var str = doc.data().abc
        if (str) {
          var n = str.charCodeAt(0);
          var number = n - 96
          arrayofNumber.push(number)
        }
      })
      arrayofNumber.sort()

      if (arrayofNumber.includes(1)) {
        for (var i = 0; i < arrayofNumber.length; i++) {
          if (arrayofNumber[i] + 1 != arrayofNumber[i + 1]) {
            lowest = this.convertNumberToABC(arrayofNumber[i] + 1)
            break;
          }
        }
      } else {
        lowest = 'a'
      }
      this.setState({ lowest })
    })
  }

  rawStringToEvalString = (cc) => {
    var intString = ''

    for (let i = 0; i < cc.length; i++) {
      var character = cc[i];
      if (character.toLowerCase() != character.toUpperCase() && character == character.toLowerCase()) {
        intString += this.getValueFromABC(character)
      } else {
        intString += character
      }
    }
    return intString
  }

  saveMember = () => {
    let raw = this.state.evastring.member

    if (!raw.includes('x')) {
      message.destroy()
      message.error("Must include x")
    } else {
      db
        .collection("project")
        .doc(this.props.match.params.id).update({
          //to do in the future: maybe convert the user editted date into isostring format, so can store together
          evastring_member: raw
        })
        .then(() => {
          message.destroy()
          message.success("Document successfully updated!");
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          message.destroy()
          message.error("Error updating document: " + error.message);
        });
    }
  }
  saveNonMember = () => {
    let raw = this.state.evastring.nonmember

    if (!raw.includes('x')) {
      message.destroy()
      message.error("Must include x")
    } else {
      db
        .collection("project")
        .doc(this.props.match.params.id).update({
          //to do in the future: maybe convert the user editted date into isostring format, so can store together
          evastring_nonmember: raw
        })
        .then(() => {
          message.destroy()
          message.success("Document successfully updated!");
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          message.destroy()
          message.error("Error updating document: " + error.message);
        });
    }
  }

  async addValue() {
    //if no title, prohibit adding new event
    if (!this.state.pendingTitle && !this.state.pendingValue) return;

    // Set a flag to indicate loading
    this.setState({ editingKey: '', addingEvent: true });


    // Add a new event from the value of the input
    // console.log("adding event titled: ", this.state.pendingTitle)
    var bb = await db.collection("values").add({
      timestamp: Date.now(),
      abc: this.state.lowest,
      keyy: this.state.pendingTitle,
      value: this.state.pendingValue,
      project: this.props.match.params.id
    })

    message.destroy()
    message.success("Document successfully updated!");
    // Remove the loading flag and clear the input
    this.setState({ addingEvent: false, pendingTitle: "" });
  }


  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  edit(key) {
    this.setState({ editingKey: key });
  }

  save(form, key) {
    form.validateFields((error, row) => {
      if (error) {
        return;
      }
      const newData = [...this.state.data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });

        db
          .collection("values")
          .doc(this.state.data[index].id).update({
            //to do in the future: maybe convert the user editted date into isostring format, so can store together
            keyy: newData[index].keyy,
            value: newData[index].value
          })
          .then(() => {
            message.destroy()
            message.success("Document successfully updated!");
            this.setState({ data: newData, editingKey: '' });
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            message.destroy()
            message.error("Error updating document: " + error.message);
          });


      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: '' });
      }
    });
  }

  cancel = () => {
    this.setState({ editingKey: '' });
  };

  render() {
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'value' ? 'number' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });


    return (
      <div>
        <h1 className="block">{this.props.match.params.name}'s packages</h1>

        <div className="gutter-box">
          <Input
            size="large"
            placeholder="Enter Item Title"
            disabled={this.state.addingEvent}
            onInput={evt => this.setState({ pendingTitle: evt.target.value })}
            value={this.state.pendingTitle}
            required
          />
        </div>
        <div className="gutter-box">
          <InputNumber
            size="large"
            placeholder="Enter Item Value"
            disabled={this.state.addingEvent}
            onChange={evt => this.setState({ pendingValue: evt })}
            value={this.state.pendingValue}
            required
          />
        </div>
        <div className="gutter-box">
          <Button
            size="large"
            type="primary"
            onClick={this.addValue}
            loading={this.state.addingEvent}
            disabled={!this.state.pendingTitle || !this.state.pendingValue}
          >
            Add Value
          </Button>
        </div>
        <Card title="Package calculator" style={{ maxWidth: 900 }}>
          <div className="gutter-box">
            x is the house price.
        </div>
          <div className="gutter-box">
            <InputNumber
              size="large"
              placeholder="Enter house price"
              disabled={this.state.addingEvent}
              onChange={evt => {
                this.setState({ x: evt }, () => {
                  let evastring = this.state.evastring
                  try {
                    evastring.member_result = eval(this.rawStringToEvalString(evastring.member))
                  } catch (e) {
                    if (e instanceof SyntaxError) {
                      evastring.member_result = e.message
                    }
                  }
                  this.setState({ evastring })
                })


              }}
              value={this.state.x}
              required
            />
          </div>
          <br></br>
          <div className="gutter-box w-500">
            <Input
              size="large"
              placeholder="member evastring"
              disabled={this.state.addingEvent}
              onInput={evt => {
                let evastring = this.state.evastring
                evastring.member = evt.target.value

                try {
                  evastring.member_result = eval(this.rawStringToEvalString(evt.target.value))
                } catch (e) {
                  if (e instanceof SyntaxError) {
                    evastring.member_result = e.message
                  }
                }
                this.setState({ evastring })
              }}
              value={this.state.evastring.member}
              required
            />
          </div>
          <div className="gutter-box">
            <Button
              size="large"
              type="primary"
              onClick={this.saveMember}
              disabled={isNaN(this.state.evastring.member_result)}
            >
              save member
          </Button>
          </div>
          <div className="gutter-box">
            {this.state.evastring.member_result}
          </div>
          <br></br>
          <div className="gutter-box w-500">
            <Input
              size="large"
              placeholder="non member evastring"
              disabled={this.state.addingEvent}
              onInput={evt => {
                let evastring = this.state.evastring
                evastring.nonmember = evt.target.value

                try {
                  evastring.nonmember_result = eval(this.rawStringToEvalString(evt.target.value))
                } catch (e) {
                  if (e instanceof SyntaxError) {
                    evastring.nonmember_result = e.message
                  }
                }
                this.setState({ evastring })
              }}
              value={this.state.evastring.nonmember}
              required
            />
          </div>
          <div className="gutter-box">
            <Button
              size="large"
              type="primary"
              onClick={this.saveNonMember}
              disabled={isNaN(this.state.evastring.nonmember_result)}
            >
              save nonmember
          </Button>
          </div>
          <div className="gutter-box">
            {this.state.evastring.nonmember_result}
          </div>
        </Card>
        <Divider></Divider>


        <Table
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
        />
        {this.state.invalidPage ?
          <Redirect to='/dashboard' />
          :
          <div />
        }
      </div>
    )
  }
}
export default Values;



// WEBPACK FOOTER //
// ./src/views/values.js